export const Join = 'Join';
export const Leave = 'Leave';
